import {joinStrings} from '#util/stringUtils';

export const minimumScores = {
  low: 51,
  mid: 70,
  high: 86,
  max: 100,
};

export const determineLifestyleScoreValue = <T>(score: number, values: T[]): T => {
  if (score < minimumScores.low) {
    return values[0];
  } else if (score < minimumScores.mid) {
    return values[1];
  } else if (score < minimumScores.high) {
    return values[2];
  } else {
    return values[3];
  }
};

export const getLifestyleScoreRating = (value: number): string => {
  return determineLifestyleScoreValue(value, ['Needs work', 'Fair', 'Good', 'Great']);
};

export const getLifestyleScoreTitle = (value: number): string => {
  return determineLifestyleScoreValue(value, [
    'less healthy',
    'moderately healthy',
    'healthy',
    'very healthy',
  ]);
};

export const getEyebrowExpanded = (value: number): string => {
  return determineLifestyleScoreValue(value, [
    'This is a growth area for you.',
    "There's room for improvement.",
    "You're doing a good job.",
    "You're doing great!",
  ]);
};

export const getNormalizedLifestyleScore = (categoryScore: number, maxCategoryScore: number) => {
  return Math.round((categoryScore / maxCategoryScore) * 100);
};

export const getCategorySatisfactionSummary = (
  categoriesMeetingRequirementsTitles: string[],
  categoriesNotMeetingRequirementsTitles: string[],
): string | null => {
  const summaries: string[] = [];

  if (categoriesMeetingRequirementsTitles.length <= 0) {
    summaries.push(
      `Lifestyle choices dramatically affect your TallyAge™ and overall health. Your scores across different lifestyle categories may be low at the moment, but small changes can make a huge impact.`,
    );
  } else if (categoriesNotMeetingRequirementsTitles.length <= 0) {
    summaries.push(
      `Great job! You take your health seriously and it shows. Although your scores are awesome, there's always room for improvement.`,
    );
  } else {
    if (categoriesNotMeetingRequirementsTitles.length > 0) {
      summaries.push(
        `You can lower your TallyAge™ by focusing on ${joinStrings(
          categoriesNotMeetingRequirementsTitles,
        )}.`,
      );
    }
  }

  return summaries.length > 0 ? summaries.join(' ') : null;
};
